import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class UploadedFileService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('UploadedFile');
	}
	download(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/Download/' + id ??'');
	}
	downloadCustomerAccountTemplate(): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/DownloadCustomerAccountFile');
	}
	downloadAccountUserTemplate(): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/DownloadAccountUserFile');
	}
	loadAll(type: number): Observable<TooBig4Car.Logic.UploadedFile[]> {
		return this.myBaseService.loadAll(this.url +'?type=' + (type ?? 0));
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.get(id, this.url);
	}
	getColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedPickupDeliveryFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditColumns');
	}
	saveColumn(tempItem: TooBig4Car.Logic.UploadedPickupDeliveryFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditColumns',true);
	}
	getPropertyColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedTypePropertyFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditPropertyColumns');
	}
	savePropertyColumn(tempItem: TooBig4Car.Logic.UploadedTypePropertyFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditPropertyColumns', true);
	}
	
	getPropertyItemColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedPropertyItemFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditPropertyItemColumns');
	}
	savePropertyItemColumn(tempItem: TooBig4Car.Logic.UploadedPropertyItemFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditPropertyItemColumns', true);
	}
	getStorageLocationColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedStorageFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditStorageLocationColumns');
	}
	saveStorageLocationColumn(tempItem: TooBig4Car.Logic.UploadedStorageFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditStorageLocationColumns', true);
	}

	getDeliveryZoneGroupColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedDeliveryZoneGroupFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditDeliveryZoneGroupColumns');
	}
	saveDeliveryZoneGroupColumn(tempItem: TooBig4Car.Logic.UploadedDeliveryZoneGroupFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditDeliveryZoneGroupColumns', true);
	}

	getCustomerAccountColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedCustomerAccountFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditCustomerAccountColumns');
	}
	saveCustomerAccountColumn(tempItem: TooBig4Car.Logic.UploadedCustomerAccountFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditCustomerAccountColumns', true);
	}

	getAccountUserColumnEdit(id: System.Guid): Observable<TooBig4Car.Logic.UploadedAccountUserFileColumnMapperVM> {
		return this.myBaseService.get(id, this.url + '/EditAccountUserColumns');
	}
	saveAccountUserColumn(tempItem: TooBig4Car.Logic.UploadedAccountUserFileColumnMapperVM): Observable<TooBig4Car.Logic.UploadedFile> {
		return this.myBaseService.post(tempItem, this.url + '/EditAccountUserColumns', true);
	}
	
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}

